import React, { Component } from "react";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';

export default class ProjectSingleImage extends Component {

	constructor(props) {
		super(props)
		this.onIntersection = this.onIntersection.bind(this)
		this.state = {
			inView: false,
		}
	}

	componentDidMount() {
		if (this.$box) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let observer = new IntersectionObserver(this.onIntersection, options);
			observer.observe(this.$box);
		}
	}

	onIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.inView === false) {
				this.setState({ inView: true });
			}						
		});
	} 
	 	
	render () {
		
		let block = this.props.block;
	
		if (block) {
						
		    return (
			    
			    <div className={'c-page__block ' + (this.state.inView ? "state-in-view" : "")} ref={(box) => { this.$box = box; }}>
			    			    						
					<div className="c-project__single-image">
						
						<div className="c-project__single-image__inner" style={{paddingTop:((block.img_height/block.img_width)*100)+'%'}}>
							
							<div className={'c-project__single-image__media c-project__single-image__media--' + block.layout}>
								
								{block.src && block.poster &&
							
									<Cinemagraph src={block.src} poster={block.poster} width={block.img_width} height={block.img_height} />
								
								}
								
								{block.src && !block.poster &&
							
									<Image src={block.src} srcset={block.srcset} width={block.img_width} height={block.img_height} />
								
								}
								
							</div>
							
						</div>
															
					</div>
					
				</div>
									    
			)
			
		} else {
			
			return null;
		
		}
	}
}
